const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

const formatTimeDigital = (s: number): string => {
    const hours = Math.floor(s / 3600);
    const minutes = Math.floor((s - hours * 3600) / 60);
    const seconds = Math.floor(s - hours * 3600 - minutes * 60);
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

const formatTime = (m: number): string => {
    const hours = Math.floor(m / 60);
    const minutes = Math.floor(m % 60);
    return `${hours}:${pad(minutes)}`;
};

export { formatTime, formatTimeDigital };
